<div class="home">
    <!-- Banner -->
    <div class="sec-banner">
        <app-slider-banner [dataBannerSlider]="dataSliderBanner"></app-slider-banner>
    </div>
    <!-- About Sagro -->
    <div class="sec-about center" id="sec-2">
        <div class="container-lg container-fluid">
            <div class="row">
                <div class="col-lg-12 col-sm-11 mx-auto wid-about">
                    <app-two-way-slider [dataTwoSlider]="dataAbout"
                                        [curData]="dataAboutCur"
                                        [curDataDesc]="dataAboutCurDesc">
                    </app-two-way-slider>
                </div>
                <div class="col-lg-12 col-sm-11 mx-auto mt-4 wid-sustain pb-lg-4">
                    <app-tab-sustainable [dataTabSustain]="dataSustain"
                                         [curData]="dataSustainCur"
                                         [curDataDesc]="dataSustainCurDesc">
                    </app-tab-sustainable>
                </div>
            </div>
        </div>
    </div>
    <!-- Articles -->
    <div class="sec-article center center-2">
        <div class="container">
           <div class="row">
               <div class="col-md-12">
                    <div class="section-articles">
                        <h3 class="fw-400 text-center mb-2">
                            {{ isLang?.news }} {{ isLang?.and }} {{ isLang?.events }}
                        </h3>
                        <!-- Articles -->
                        <!-- desktop -->
                        <div class="row px-2 d-xl-flex d-none" *ngIf="dataArticle?.length != 0">
                            <!-- article -->
                            <div class="col-md-4 p-1" *ngFor="let article of dataArticle | slice:0:9">
                                <app-card-article [dataArticle]="article" 
                                                [type]="article.category.title"
                                                [height]="'163px'">
                                </app-card-article>
                            </div>
                        </div>
                        <!-- mobile -->
                        <div class="d-xl-none d-block" *ngIf="dataArticle?.length != 0">
                            <!-- article -->
                            <ngx-slick-carousel class="carousel" 
                                #slickModalArticle="slick-carousel" 
                                [config]="slideArticlesConfig">
                                <div ngxSlickItem 
                                    class="slide p-2"
                                    *ngFor="let article of dataArticle | slice:0:8">
                                    <app-card-article [dataArticle]="article" 
                                                        [type]="article.category.title"
                                                        [height]="'163px'">
                                    </app-card-article>
                                </div>
                            </ngx-slick-carousel>
                            <div class="prev-next mt-3 pr-2 text-right">
                                <span class="circle mr-2" (click)="slickModalArticle.slickPrev()">
                                    <i class="icon ion-ios-arrow-back"></i>
                                </span>
                                <span class="circle" (click)="slickModalArticle.slickNext()">
                                    <i class="icon ion-ios-arrow-forward"></i>
                                </span>
                            </div>
                        </div>
                        <div style="height: 300px" 
                            *ngIf="dataArticle?.length == 0"
                            class="d-flex w-100 align-items-center justify-content-center">
                            <h6>{{ isLang?.noData }}</h6>
                        </div>
                    </div>
               </div>
                <!-- Subscribe -->
                <div class="col-md-12 subscribe mt-3">
                    <div class="row">
                         <div class="col-lg-9 col-md-8">
                             <app-subscribe></app-subscribe>
                         </div>
                         <div class="text-right col-lg-3 col-md-4">
                             <a routerLink="/news-and-events" class="link-page">
                                 {{ isLang?.seeMoreUpdate }} 
                                 <img class="icon pl-3" src="../../../assets/images/icon/arrow-left.svg" alt="">
                             </a>
                         </div>
                    </div>
                </div>
           </div>
        </div>
    </div>
    <!-- Fundamental -->
    <div class="sec-fundamental position-relative center">
        <div class="maps d-md-block d-none">
            <img src="../../../assets/images/maps.png" alt="">
        </div>
        <div class="container-lg container-fluid" *ngIf="dataBuilding">
            <div class="row">
                <div class="col-lg-12 col-sm-11 mx-auto">
                    <app-fundamental [dataFundamental]="dataBuilding"></app-fundamental>
                </div>
            </div>
        </div>
    </div>
    <!-- Products -->
    <div class="sec-products center center-2">
       <div class="container-lg container-fluid">
           <div class="row">
               <div class="col-lg-12 col-sm-11 mx-auto pb-4 wid-product">
                    <app-two-way-slider [dataTwoSlider]="dataProduct" 
                                        [versi]="2"
                                        [curData]="dataProductCur"
                                        [curDataDesc]="dataProductCurDesc">
                    </app-two-way-slider>
               </div>
               <div class="col-lg-12 col-sm-11 mx-auto pt-3 wid-docs">
                   <div class="row">
                       <div class="col-md-5 pb-md-0 pb-4">
                            <app-widget-shareholding></app-widget-shareholding>
                       </div>
                       <div class="col-md-7 pt-md-0 pt-3">
                            <app-widget-documents></app-widget-documents>
                       </div>   
                   </div>
               </div>
           </div>
       </div>
    </div>
    <!-- Gallery -->
    <div class="sec-gallery center">
        <div class="container-lg container-fluid">
            <div class="row">
                <div class="col-lg-12 col-sm-11 mx-auto">
                    <div class="row align-items-end mb-4">
                        <div class="col-md-4 pl-4">
                            <h3 class="fw-400">{{ isLang?.gallery }}</h3>
                        </div>
                        <div class="col-md-8 text-right">
                            <a routerLink="/gallery" class="link-page">
                                {{ isLang?.more }} 
                                <img class="icon pl-3" src="../../../assets/images/icon/arrow-left.svg" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="slide-gal text-center">
            <ngx-slick-carousel 
                class="carousel" 
                #slickModalGal="slick-carousel" 
                [config]="slideGalleryConfig">
                <div ngxSlickItem 
                    *ngFor="let gal of dataGallery; let key = index" 
                    class="slide"
                    style="width: 350px"
                    id="{{ key }}">
                    <app-gallery [dataGallery]="gal" [versi]="'2'"></app-gallery>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>  
</div>



